// Import pages
import ConsumerPageMobile from './consumerPage.svelte';
import Team from './Team/mobileTeam.svelte';
import AdvertPage from './advert.svelte';
import InvestPage from './invest.svelte';
// import Team from './mobile/Team/team.svelte';
import landingPage from './landingPage';
import ScrollExample from './scroll_example.svelte';
import Gamers from './Gamerpages/headerSection.svelte';
import StoryTeller from './Storyteller/index.svelte';
import Artist from './Artist_Musician/index.svelte';
import Performnace from './performers/showall.svelte';
import Create from './technical.svelte';
import Demo from './demo.svelte';
export default {
    '/': landingPage,
    '/consumerpagemobile': ConsumerPageMobile,
    '/ScrollExample': ScrollExample,
    '/demo': Demo,
    '/AdvertPage': AdvertPage,
    '/InvestPage': InvestPage,
    '/Team': Team,
    '/gamers': Gamers,
    '/story': StoryTeller,
    '/artist': Artist,
    '/demo': Demo,
    '/performance': Performnace,
    '/Create': Create,
    // '/Team': Team,
};
